import React from 'react';
import { IGhgFuelRow } from 'models/ghg-emission-report';
import { emission, percent, quantity, TCO2E } from './format';

interface GhgFuelTableProps {
    fuels: IGhgFuelRow[];
    actualEmission: number;
}

export default function GhgFuelTable(props: GhgFuelTableProps) {
    return (
        <>
            <h3 className="u-fs-18 font-weight-bold mb-3">
                Detailne ülevaade valitud perioodil tekkinud KHG-heitest
            </h3>

            <div className="table-responsive">
                <table className="table ghg-table mb-0">
                    <thead>
                        <tr>
                            <th>Transpordikütus</th>
                            <th className="text-right">Tarbimine</th>
                            <th>Ühik</th>
                            <th className="text-right">KHG-heide, {TCO2E}</th>
                            <th className="text-right">Osakaal</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.fuels.map(fuel => (
                            <tr key={fuel.fuelType}>
                                <td>{fuel.label}</td>
                                <td className="text-right">{quantity(fuel.quantity)}</td>
                                <td>{fuel.unit}</td>
                                <td className="text-right">{emission(fuel.emission)}</td>
                                <td className="text-right">{percent(fuel.sharePct)}%</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr className="font-weight-bold">
                            <td>Kokku</td>
                            <td />
                            <td />
                            <td className="text-right">{emission(props.actualEmission)}</td>
                            <td className="text-right">{percent(props.fuels.length ? 100 : 0)}%</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </>
    );
}
